import { DialogService, GridAction } from '@eforall/dashboard';
import { EmailSentRow } from '../person-emails-sent.part';

export function getActions(dialog: DialogService) {

	const actions: GridAction<EmailSentRow>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialog.showMessage('Details', rows[0]!.jobTriggerDescriptionMD);
			}
		},
	];

	return actions;
}